import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';
import { BillingControlService } from '../service/billing-control.service';

@Component({
  selector: 'app-bc-effective-culture',
  templateUrl: './bc-effective-culture.component.html',
  styleUrls: ['./bc-effective-culture.component.scss']
})
export class BcEffectiveCultureComponent implements OnInit {

  private BcCultureData = [];
  private BcCultureTotal = 0;

  //Chart Configuration and Data
  private hasLegend = false
  private chartType = 'horizontalBar'
  private chartData = [
    {
      data: [],
      label: ['porcentagem']
    }
  ];
  private chartLabels = [];
  private showChart = false;
  private showAll;

  constructor(private billingControlService: BillingControlService, private dialogService: DialogService) {
  }

  ngOnInit() {
    this.getBCCulture();
  }

  getBCCulture() {
    this.billingControlService.getBCCulture(this.showAll).subscribe(result => {
      if (result.Success) {
        this.BcCultureData = result.Result || [];
        this.BcCultureTotal = result.Total;
        this.defineChartByData();
      } else {
        console.log("Erro ao carregar dados de Cobrança Geral");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByData() {
    if (this.BcCultureData.length > 1) {
      this.BcCultureData.forEach((row, index) => {
        row.Nome ? this.addChartData(row.Nome, row.Percentual) : this.addChartData('Sem cultura', row.Percentual);
        if (index == this.BcCultureData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }

  onShowAll() {
    this.showAll = true;
    this.getBCCulture();
  }

  onShowLess() {
    this.showAll = false;
    this.getBCCulture();
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-effective-culture/bc-effective-culture.component.ts